const en_sales_refItemOut = {

    message: {
        reject_do_title: "Are you sure you want to cancel the DO?",
        reject_do_text: "Enter the reason for cancelling the DO.",
    },

    error: {
        reject: "Failed to cancel DO OUT.",
    },

    success: {
        reject: "DO OUT cancelled successfully.",
    },
}

export default en_sales_refItemOut;